module.exports = __webpack_public_path__ + "1b2a3216bb3dcc5b2dce751beca4340c.svg";